<av-global-loader />
<router-outlet />
